import axios from '../util/axios';
import Token from '../util/Token';

const BASE_URL = '/cms/v1/team';

// Returns { config, resolved } — `config` is the raw per-team override (null when
// unset) and `resolved` is the effective constants the backend actually uses
// (built-in default <- env <- override), shaped like CARBON_CONSTANTS.
async function getTeamCarbonConfig(teamId) {
  try {
    Token.setAuthToken();
    const response = await axios.get(`${BASE_URL}/${teamId}/carbon-config`);
    return response.data;
  } catch (error) {
    console.error('Error fetching team carbon config:', error);
    throw error;
  }
}

async function updateTeamCarbonConfig(teamId, payload) {
  try {
    Token.setAuthToken();
    const response = await axios.put(`${BASE_URL}/${teamId}/carbon-config`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating team carbon config:', error);
    throw error;
  }
}

const carbonConfigService = {
  getTeamCarbonConfig,
  updateTeamCarbonConfig,
};

export default carbonConfigService;
